export default __webpack_public_path__ + "static/apps-for-controllers-b1a491d756cf339ac31d3283f944bbfe.webp";